import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserPasswordChangeFormComponent } from './user-password-change-form/user-password-change-form.component';
import { AppPageComponent, AppBarComponent, AppBarCloseAction, AppBarTitleComponent, UserMessageGuard } from 'common';
import { SsoAccountCurrentResolver } from 'common';
import { OAuthGuard } from '../../guards/oauth.guard';

const routes: Routes = [
  {
    path: 'user/change-password',
    component: AppPageComponent,
    data: {
      appBar: {
        closeAction: AppBarCloseAction.HOME,
        logoHidden: true,
        stickyDisabled: true
      }
    },
    canActivate: [OAuthGuard, UserMessageGuard],
    children: [
      {
        path: '',
        outlet: 'app-bar',
        component: AppBarComponent,
        children: [
          {
            path: '',
            outlet: 'title',
            component: AppBarTitleComponent,
          }
        ]
      },
      {
        path: '',
        component: UserPasswordChangeFormComponent,
        resolve: {
          currentAccount: SsoAccountCurrentResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
